import DataAccess from './constants';
import API from './API';
const path = 'UniqueCouponHolds/UniqueCouponHolds';

let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const uniqueCouponPost = (uniqueCouponCode) => {
    return api.postData(path , uniqueCouponCode);
}

export const deleteUniqueCouponHolds = (params) => {
    return api.deleteData(path + params, {});
}